module.exports = __webpack_public_path__ + "img/header.6b5950a9.png";